module.exports = __webpack_public_path__ + "img/placeholder.60aeaee2.jpg";